import React from "react";

export const SectionLabel = ({ children, dark = false, testid }) => (
  <div
    data-testid={testid}
    className={`inline-flex items-center gap-3 text-[11px] tracking-label uppercase font-semibold ${
      dark ? "text-white/60" : "text-[var(--sifra-ink-mute)]"
    }`}
  >
    <span
      className={`w-8 h-px ${dark ? "bg-white/40" : "bg-[var(--sifra-ink)]"}`}
    />
    {children}
  </div>
);

export default SectionLabel;
